<template>
    <router-view/>
</template>

/*共通部*/
<style>
    .contents {
        font-size: 30px;
        margin: 50px 0 0 0;
    }
    #app {
        background: #e7e6e6;
        text-align: center;
    }
    * {
        font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Meiryo", sans-serif;
        font-size: 16px;
        line-height: 1.7;
        color: #4a4a4a;
        margin: 0;
        padding: 0;
    }
    html {
        background: #e7e6e6;
        min-height: calc(100vh - 46vh);
        position: relative;
        box-sizing: border-box;
    }
    /* コンテンツ関連 */
    .mainView{
        margin-left: max(25%, 320px);
        margin-right : 5%;
        background: #f9f7f7af;
        box-sizing: border-box;
        padding:20px;
    }
    .title{
        text-align: left;
        padding: 10px 0 0 20px;
        font-size: 25px;
        font-weight: bold;
    }
    .titleTextArea{
        margin:0 20px 30px 20px;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid #cecbcb;
        display: flex;
    }
    .titleText{
        text-align: left;
        font-size: 20px;
    }
    input {
        height: 40px;
        text-indent: 1em;
    }
    .fontColorPk{
        color:#ff1493;
        font-weight:bold;
    }
    .textLeft{
        text-align: left;
    }
    .successView{
        color:rgb(19, 141, 19);
        background-color: #dbf8dc;
        border:none;
        padding: 5px 15px;
        border-radius: 10px;
        font-weight: bold;
    }
    .failView{
        color:#ff1493;
        background-color: #f8dbf1;
        border:none;
        padding: 5px 15px;
        border-radius: 10px;
        font-weight: bold;
    }
    .requireView{
        color:#ff1493;
        background-color: white;
        border: solid #ff1493 2px;
        padding: 5px 15px;
        border-radius: 10px;
        font-weight: bold;
        margin-left: 5px;
    }
    .optionalView{
        color: #555;
        background-color: #eae6e7;
        border: solid #eae6e7 2px;
        padding: 5px 15px;
        border-radius: 10px;
        font-weight: bold;
        margin-left: 5px;
    }
    /* 顔画像登録(最大3枚)関係 */
    .maxImageBadge{
        color:#ff1493;
        background-color: white;
        border: solid #ff1493 2px;
        padding: 2px 10px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: bold;
        margin-left: 8px;
        vertical-align: middle;
    }
    .imgDescription{
        padding: 0 10px;
        margin: 0 0 5px 0;
    }
    .imgOverwriteNote{
        color: #e60000;
        font-size: 14px;
        padding: 0 10px;
        margin: 0 0 5px 0;
    }

    @media (max-width: 1150px) {
        .title {
            font-size: 32px;
            margin-top:15px;
        }
    }
    @media (max-width: 768px) {
        .title {
            font-size: 24px;
        }
        .titleText {
            font-size: 14px;
        }
    }
    
    /* ページネーション関係↓ */
    .pagination-area {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        gap:20px;
    }
    .pagination {
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .page-btn {
        width: 34px;
        height: 34px;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        background: #fff;
        cursor: pointer;
        color: #666;
        font-size: 14px;
    }
    .page-btn:hover:not(:disabled) {
        background: #f5f5f5;
    }
    .page-btn.active {
        background: #ff0a8a;
        color: white;
        border-color: #ff0a8a;
    }
    .page-btn:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
    .page-size {
        height: 34px;
        padding: 0 12px;
        border: 1px solid #ddd;
        border-radius: 6px;
        background: white;
    }
    /* ページネーション関係↑ */
    
    /* テーブル関連 */
    .commonTable {
        width: 100%;
        margin: 0 0 0 0;
        border-collapse: collapse;
        border: none;
    }
    .commonTable tr {
        height: 60px;
    }
    .commonTable th {
        white-space: nowrap;
        height: 75px;
        color: #585757;
        background-color: #d6d1d1;
        text-align: left;
        padding-left: 20px;
    }
    .commonTable td {
        border-top: solid 1px;
        background-color: white;
        text-align: left;
        padding-left: 20px;
    }
    .commonTable .notButtom {
        border-bottom: none;
    }
    .commonTable .notTop {
        border-top: none;
        padding-bottom:20px;
    }
    .commonTable .updateArea {
        height: 150px;
    }
    .commonTable thead tr th:first-child {
        border-top-left-radius: 8px;
    }
    .commonTable thead tr th:last-child {
        border-top-right-radius: 8px;
    }
    .firstTd {
        text-align: left;
    }
    .leftSideTh {
        text-align: left;
        padding: 0 0 0 30px;
    }
    .leftSideTd {
        text-align: left;
        padding: 10px 0 10px 30px;
    }
    .halfTh {
        width: 50%;
    }
    
    /* ボタン関連 */
    .nextButton{
        padding: 10px 30px;
        background: #ff1493;
        color: white;
        border: none;
        border-radius: 10px;
        cursor: pointer;
    }
    .nextButton.disabled,
    .nextButton:disabled {
        background: #ddd;
        color: #888;
        cursor: not-allowed;
    }
    .exeButton{
        padding: 10px 30px;
        background: white;
        color: #ff1493;
        border: solid #ff1493 2px;
        border-radius: 10px;
        cursor: pointer;
    }
    .clearButton{
        padding: 10px 30px;
        background: white;
        color: black;
        border: solid black 2px;
        border-radius: 10px;
        cursor: pointer;
    }
   
    /*スイッチ関連*/
    .switchContainer {
        display: inline-block;
    }
    .switchContainer input[type="checkbox"] {
        display: none;
    }
    .switchArea {
        position: relative;
        width: 150px;
        height: 30px;
        background: #e0e0e0;
        border-radius: 999px;
        border: solid #5e5d5d 1px;
        padding: 4px 0 4px 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }
    
    .switchText{
        margin-left: 12px;
        font-size: 14px;
        color: #2a2b2a;
        z-index: 2;
    }
    .switchSliderArea{
        width: 100px;
        height: 36px;
        position: relative;
    }
    .switchSliderInner{
        position: absolute;
        width: 100%;
        height: inherit;
        bottom: 0;
        top: 0;
        background-color: rgb(148, 145, 145);
        border-radius: 999px;
        transition: 0.3s;
    }
    .switchSlider {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 32px;
        height: 32px;
        background: white;
        border-radius: 50%;
        transition: 0.3s;
    }
    .switchContainer input:checked + .switchArea
    {
        background-color: #dbf8dc;
        border: solid rgb(19, 141, 19) 1px;
    }
    .switchContainer input:checked + .switchArea .switchText
    {
        color: rgb(19, 141, 19);
    }
    .switchContainer input:checked + .switchArea .switchSliderInner
    {
        background-color: rgb(19, 141, 19);
    }
    .switchContainer input:checked + .switchArea .switchSlider {
        transform: translateX(64px);
    }

    /* ローディング関連 */
    .loading-overlay {
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.35);
        z-index: 1000;
    }
    .loading-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        padding: 30px 40px;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.98);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
        text-align: center;
    }
    .loading-box p {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .spinner {
        width: 48px;
        height: 48px;
        border: 5px solid rgba(0, 0, 0, 0.12);
        border-top-color: #2d7cf0;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    /* パスワード関連 */
    .checkPassword {
        display: none;
        border: none;
    }
    .togglePassword {
        margin: 0 2% 0 2%;
        width: 96%;
        text-align: left;
        background-color: #EEEEEF;
        border-radius: 10px;
    }
    .hideText, .showText {
        width: 100%;
        border: none;
        outline: none;
        /*padding: 0 20px 0 0;*/
        text-align: left;
        background-color: #EEEEEF;
        border-radius: 10px;
    }
    .hideText {
        display: inline;
        width: 100%;
    }

    @media (max-width: 1150px) {
        .mainView {
            margin-left: 0;
            margin-right: 0;
            padding: 16px;
        }
        .titleTextArea {
            flex-direction: column;
            align-items: stretch;
            margin: 0 0 20px 0;
        }
        .title {
            font-size: 22px;
            padding-left: 10px;
        }
        .titleText {
            font-size: 18px;
        }
        .pagination-area {
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;
        }
        .page-btn {
            min-width: 40px;
        }
        .page-size {
            width: 100%;
            max-width: 250px;
        }
        .commonTable {
            min-width: 0;
            width: 100%;
        }
        .commonTable th,
        .commonTable td {
            padding-left: 12px;
            font-size: 14px;
        }
        .nextButton,
        .exeButton,
        .clearButton {
            width: 80%;
            padding: 12px 18px;
        }
    }

    @media (max-width: 768px) {
        html {
            min-height: auto;
        }
        .mainView {
            padding: 14px;
        }
        .title {
            font-size: 24px;
        }
        .titleText {
            font-size: 16px;
        }
        input {
            width: 100%;
        }
        .switchArea {
            width: 100%;
        }
        .switchText {
            font-size: 13px;
        }
        .page-btn {
            width: 34px;
            height: 34px;
        }
        .page-size {
            width: 100%;
        }
    }

    @media (max-width: 540px) {
        .mainView {
            padding: 12px;
        }
        .title {
            font-size: 20px;
        }
        .titleTextArea {
            margin: 0 0 16px 0;
        }
        .nextButton,
        .exeButton,
        .clearButton {
            width: 70%;
            padding: 5px 10px;
            border-radius: 8px;
        }
    }

</style>
